import React, { CSSProperties, useEffect } from "react";
import {
  Button,
  DatePicker,
  Form,
  ImageUploader,
  Input,
  List,
  Modal,
  TextArea,
  Toast,
  Image,
  Space,
  Radio,
  Dialog,
  ActionSheet,
  Picker,
} from "antd-mobile";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { queryAncientInfoById, queryAncientInspectById, saveAncientInspect } from "./service";
import { useState } from "react";
import dayjs from "dayjs";
import { FileUpload, wxsign, locationChange, place } from "../../services/index";
import { ImageUploadItem } from "antd-mobile/es/components/image-uploader";
import { AddCircleOutline, CloseCircleOutline } from "antd-mobile-icons";
import { WX_APPID } from "../../config";
import { isAndroid } from "../../utils/deviceUtils";
import storageUtil from "../../utils/storageUtil";
import { Action } from "antd-mobile/es/components/action-sheet";
import { queryDictionaryItemById } from "../TreeCreateScreen/service";


const wx = require("weixin-js-sdk");

interface IPicker {
  label: string;
  value: string;
}

const InspectCreacteScreen: React.FC = React.memo((props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const id: any = location.state;
  const [form] = Form.useForm();
  const [saveProblem] = Form.useForm();
  const [dataPickerVisible, setDataPickerVisible] = useState(false);
  const [inspectTime, setInspectTime] = useState<string>("");
  const [beforeFiles, setBeforeFiles] = useState<ImageUploadItem[]>([]);
  const [afterFiles, setAfterFiles] = useState<ImageUploadItem[]>([]);
  const [fileList, setFileList] = useState<APICommon.FileItem[]>([]);
  const [complainantType, setComplainantType] = useState<string>("");
  const params = useParams<{ id: string }>();
  const [problems, setProblems] = useState<APIGarden.AncientProblemItem[]>([]);
  const [url, setUrl] = useState("");
  const [inspect, setInspect] = useState<Partial<APIGarden.AncientItem> | undefined>(undefined);
  const [index, setIndex] = useState<number>();
  const [sheetVisible, setSheetVisible] = useState(false);
  const [imgId, setImgId] = useState<string>("");
  const [imgFiles, setImgFiles] = useState<APICommon.FileItem[] | undefined>([]);
  const [imgIndex, setImgIndex] = useState<number>();
  const [companyDic, setCompanyDic] = useState<IPicker[]>([]);
  const [comoanyVisible, setComoanyVisible] = useState(false);
  const [companyName, setCompanyName] = useState<string>("");

  useEffect(() => {
    const init = async () => {
      const signUrl = isAndroid()
        ? window.location.href
        : await storageUtil.getItem("INDEX_URL", false);
      setUrl(signUrl);
    };
    init();
  }, []);

  useEffect(() => {
    setFileList([]);
    if (id) {
      queryAncientInspectById(id).then((data) => {
        if (data && data.obj) {
          setInspect(data.obj);
          form.setFieldsValue({
            ...data.obj,
          });
          setInspectTime(data.obj.inspectTime);
          if (data.obj.problems) setProblems(data.obj.problems);
          if (data.obj.companyName) setCompanyName(data.obj.companyName);
        };
      });
    } else {
      if (params.id) {
        queryAncientInfoById(params.id).then((data) => {
          if (data && data.obj.treeSpecies) {
            form.setFieldsValue({
              treeSpecies: data.obj.treeSpecies,
              number: data.obj.number,
              address: data.obj.placeName,
              manageCompany: data.obj.managementUnitName,
            });
          }
        });
      }
    };
    if (url) {
      wxsign(url)
        .then((data) => {
          if (data) {
            // 通过config接口注入权限验证配置
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: WX_APPID, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名
              jsApiList: ["getLocation"], // 必填，需要使用的JS接口列表
            });
            wx.error(function (e: any) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              // message.error("签名失败，请检查微信版本");
              Toast.show({
                content: "获取微信签名失败",
                afterClose: () => { },
              });
            });
          }
        })
        .catch((error) => {
          Toast.show({
            content: "获取微信签名失败",
            afterClose: () => { },
          });
        });
    }

    //获取单位数据字典信息
    queryDictionaryItemById("934127824892067840").then((data) => {
      if (data) {
        const typeData: IPicker[] = [];
        data.list.map((type: any) => {
          typeData.push({ label: type.dictName, value: type.id });
        });
        setCompanyDic(typeData);
      }
    });
  }, [params.id, id, url, form]);

  const handleSave = async (values: APIGarden.AncientInspectItem) => {
    try {
      const resp = await saveAncientInspect({ ...values });
      if (resp.obj) {
        Toast.show({
          icon: "success",
          content: "提交成功",
        });
        navigation("/inspect/list");
      } else {
        Toast.show({
          icon: "fail",
          content: "提交失败，请重试！",
        });
      }
      return true;
    } catch (error) {
      Toast.show({
        icon: "fail",
        content: "提交失败，请重试！",
      });
      return false;
    }
  }


  const onFinish = (values: any) => {
    const problemIds: string[] = [];
    problems.forEach((elment) => {
      if (elment.id) problemIds.push(elment.id);
    });
    values.problemIds = problemIds;
    values.problems = problems;
    values.ancientId = params.id;
    handleSave({
      ...inspect,
      ...values,
    })
    //重置表单
    form.resetFields();
    setInspectTime("");
    setAfterFiles([]);
    setBeforeFiles([]);
    setProblems([]);
  };

  const setInspectTimes = (value: any) => {
    setInspectTime(dayjs(value).format("YYYY-MM-DD HH:mm:ss"));
    form.setFieldsValue({
      inspectTime: dayjs(value).format("YYYY-MM-DD HH:mm:ss"),
    });
  };

  // 保存存在的问题
  const hanldProblem = (values: any) => {
    if (values) {
      problems.push(values);
      saveProblem.resetFields();
    }
    setProblems([...problems]);
  };

  //删除存在问题
  const removeProblem = (valeus: any) => {
    if (problems.length > 1) {
      problems.splice(valeus, 1);
    } else {
      problems.pop();
    }
    setProblems([...problems]);
  };

  const setProblemInfo = (index: any, type: any) => {
    // const data:string = ""
    // data = problems[0].problem;
    setIndex(index);
    setComplainantType(type);
  }

  // 获取定位数据
  const getAddress = () => {
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res: any) {
        if (res) {
          locationChange(res.longitude, res.latitude).then((data) => {
            if (data && data.list) {
              place(data.list[0].x, data.list[0].y).then((data) => {
                if (data) {
                  form.setFieldsValue({
                    inspectSite: data.formatted_address,
                  })
                } else {
                  Toast.show({
                    content: "获取经纬度失败",
                    afterClose: () => { },
                  });
                };
              });
            } else {
              Toast.show({
                content: "获取经纬度失败",
                afterClose: () => { },
              });
            };
          });
        } else {
          Toast.show({
            content: "获取经纬度失败",
            afterClose: () => { },
          });
        }
      }
    });
  };


  //设置古树巡查图片数据
  const beforeImg = (fileInfo: ImageUploadItem[]) => {
    setBeforeFiles(fileInfo);
  };

  //设置古树整改图片数据
  const afterImg = (fileInfo: ImageUploadItem[]) => {
    setAfterFiles(fileInfo);
  };

  //上传附件
  const mockUpload = (file: File) => {
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
      formData.append("type", "/ancient/inspect");
      FileUpload(formData).then((data) => {
        if (data) {
          fileList.push({
            id: data.list[0].uid,
            linkType: complainantType,
            fileName: data.list[0].originalName,
            fileExt: data.list[0].contentType,
            fileSize: data.list[0].fileSize,
            filePath: data.list[0].filePath,
            filePathFull: data.list[0].filePathFull,
            gmtCreate: data.list[0].uploadDate,
          });
          // setFileList([...fileList]);
          if (index !== undefined) {
            const list: APIGarden.AncientProblemItem = problems[index];
            if (list.files && list.files.length > 0) {
              fileList.forEach((elment) => {
                list.files?.push(elment);
              });
            } else {
              list.files = fileList;
            }
            problems.splice(index, 1, { ...list });
            setFileList([]);
          }
        }
      });
    }
    throw new Error('')
  };

  //删除图片操作
  const sheet = (id: string, valeus: any, index: number) => {
    setImgId(id);
    setImgIndex(index)
    setImgFiles(valeus);
    setSheetVisible(true);
  };
  const actions: Action[] = [
    {
      text: "删除",
      key: "delete",
      description: "删除后数据不可恢复",
      danger: true,
      onClick: async () => {
        const result = await Dialog.confirm({ content: "确定要删除吗？" });
        if (result) {
          if (imgFiles) {
            imgFiles.map((item, index) => {
              if (imgId === item.id) {
                if (imgFiles.length > 1) {
                  imgFiles.splice(index, 1)
                } else {
                  imgFiles.pop();
                }
              }
              setImgFiles([...imgFiles]);
              if (imgIndex !== undefined) {
                const list: APIGarden.AncientProblemItem = problems[imgIndex];
                list.files = imgFiles;
                problems.splice(imgIndex, 1, { ...list });
                setSheetVisible(false);
              }
            })
          }
        }
      },
    },
    {
      text: "取消",
      key: "cancel",
      onClick: async () => {
        setSheetVisible(false);
      },
    },
  ];

  const setStatus = (val: any, index: number) => {
    const data: APIGarden.AncientProblemItem = problems[index];
    data.status = val;
    problems.splice(index, 1, { ...data });
  }

  const setCompanyInfo = (label: any, value: any) => {
    setCompanyName(label);
    form.setFieldsValue({
      company: value,
    });
  };

  return (
    <div style={container}>
      <Form
        form={form}
        onFinish={onFinish}
        layout="horizontal"
        mode="card"
        footer={
          <div>
            <div style={submitBut}>
              <Button block type="submit" color="primary" size="large">
                提交
              </Button>
            </div>
          </div>
        }
      >
        <Form.Header>基本信息</Form.Header>
        <Form.Item
          name="company"
          label="单位"
          onClick={() => {
            setComoanyVisible(true);
          }}
          rules={[{ required: companyName === "", message: "单位不能为空" }]}
        >
          <Picker
            columns={[companyDic]}
            visible={comoanyVisible}
            onClose={() => {
              setComoanyVisible(false);
            }}
            onConfirm={(v, e) =>
              e.items.map((item) => setCompanyInfo(item?.label, item?.value))
            }
          />
          {companyName ? companyName : "请选择单位"}
        </Form.Item>
        <Form.Item
          name="number"
          label="编号"
          rules={[{ required: true, message: "编号不能为空" }]}
        >
          <Input
            type="number"
            placeholder="请输入编号"
            style={{ width: 400 }}
          />
        </Form.Item>
        <Form.Item
          name="treeSpecies"
          label="树种"
          rules={[{ required: true, message: "树种不能为空" }]}
        >
          <Input placeholder="请输入树种" readOnly />
        </Form.Item>
        <Form.Item
          name="address"
          label="古树地址"
          rules={[{ required: true, message: "古树地址不能为空" }]}
        >
          <Input placeholder="请输入古树地址" />
        </Form.Item>
        <Form.Item
          name="manageCompany"
          label="管理责任单位"
          rules={[{ required: true, message: "管理责任单位不能为空" }]}
        >
          <Input placeholder="请输入管理责任单位" />
        </Form.Item>
        <Form.Item
          name="inspectSite"
          label="巡查地址"
          extra={
            <div>
              <a onClick={() => getAddress()}>获取位置</a>
            </div>
          }
          rules={[{ required: true, message: "巡查地址不能为空" }]}
        >
          <Input placeholder="获取当前位置" />
        </Form.Item>
        <Form.Item
          name="inspectTime"
          label="巡查时间"
          onClick={() => {
            setDataPickerVisible(true);
          }}
          rules={[{ required: true, message: "巡查时间不能为空" }]}
        >
          <DatePicker
            precision="minute"
            visible={dataPickerVisible}
            onClose={() => {
              setDataPickerVisible(false);
            }}
            onConfirm={(v) => setInspectTimes(v)}
          />
          {inspectTime ? inspectTime : "请选择巡查时间"}
        </Form.Item>
        <Form.Header>存在的问题</Form.Header>
        {problems && (
          <List>
            {problems.map((item, index) => (
              <div>
                <List.Item
                  title={<span>存在的问题{index + 1}</span>}
                  key={index}
                  extra={
                    <CloseCircleOutline
                      fontSize={24}
                      color="var(--adm-color-danger)"
                      onClick={() => {
                        removeProblem(index);
                      }}
                    />
                  }
                >
                  <div> {item.problem ? item.problem : ""}</div>
                </List.Item>
                <List.Item
                  title={<span>树木巡查前图片</span>}
                >
                  <Space
                  >
                    {
                      item.files?.map((file) =>
                        file.linkType === "树木巡查前图片" ?
                          <Space
                            style={{ padding: "5px" }}
                            onClick={() =>
                              sheet(file.id, item.files, index)
                            }
                          >
                            <Image
                              src={file.filePathFull ? file.filePathFull : ""}
                              style={{ borderRadius: 4 }}
                              width={50}
                              height={50}
                            />
                          </Space> : null
                      )
                    }
                    <Space
                      style={{ paddingTop: "5px" }}
                      onClick={() => { setProblemInfo(index, "树木巡查前图片") }}
                    >
                      <ImageUploader
                        style={{ "--cell-size": "50px" }}
                        value={beforeFiles}
                        onChange={(fileList) => {
                          beforeImg(fileList);
                        }}
                        showFailed={false}
                        upload={mockUpload as any}
                      />
                    </Space>
                  </Space>
                </List.Item>
                <List.Item
                  title={<span>树木整改后图片</span>}
                >
                  <Space>
                    {
                      item.files?.map((file) =>
                        file.linkType === "树木整改后图片" ?
                          <Space
                            style={{ padding: "5px" }}
                            onClick={() =>
                              sheet(file.id, item.files, index)
                            }
                          >
                            <Image
                              src={file.filePathFull ? file.filePathFull : ""}
                              style={{ borderRadius: 4 }}
                              width={50}
                              height={50}
                            />
                          </Space> : null
                      )
                    }
                    <Space
                      style={{ paddingTop: "5px" }}
                      onClick={() => { setProblemInfo(index, "树木整改后图片") }}
                    >
                      <ImageUploader
                        style={{ "--cell-size": "50px" }}
                        value={afterFiles}
                        onChange={(fileList) => {
                          afterImg(fileList);
                        }}
                        showFailed={false}
                        upload={mockUpload as any}
                      />

                    </Space>
                  </Space>
                </List.Item>
                <List.Item
                  title={<span>状态</span>}
                >
                  <Radio.Group
                    defaultValue={item.status}
                    onChange={val => {
                      setStatus(val, index)
                    }}
                  >
                    <Space>
                      <Radio value='0'
                      >
                        进行中
                      </Radio>
                      <Radio value='1'>
                        已完成
                      </Radio>
                    </Space>
                  </Radio.Group>
                </List.Item>
              </div>
            ))}
          </List>
        )}
        <Form.Header></Form.Header>
        <Button
          size="large"
          style={{ width: "100%" }}
          onClick={async () => {
            const result = await Modal.confirm({
              content: (
                <div>
                  <Form form={saveProblem} onFinish={hanldProblem}>
                    <Form.Item
                      name="problem"
                      label="存在的问题"
                      rules={[
                        { required: true, message: "存在的问题不能为空" },
                      ]}
                    >
                      <TextArea placeholder="请输入存在的问题" />
                    </Form.Item>
                  </Form>
                </div>
              ),
            });
            if (result) {
              saveProblem.submit();
              setFileList([]);
            } else {
              saveProblem.resetFields();
              setFileList([]);
            }
          }}
        >
          <span style={{ color: "#1677ff" }}>
            <AddCircleOutline /> 添加
          </span>
        </Button>
        <Form.Header>解决方法</Form.Header>
        <Form.Item
          name="solution"
          label="解决方法"
          rules={[{ required: true, message: "解决方法不能为空" }]}
        >
          <TextArea placeholder="请输入解决方法" rows={5} />
        </Form.Item>
      </Form>
      <ActionSheet
        visible={sheetVisible}
        actions={actions}
        onClose={() => setSheetVisible(false)}
      />
    </div >
  );
});

const container: CSSProperties = {
  backgroundColor: "#f5f7fa",
};

const submitBut: CSSProperties = {
  height: "70px",
  backgroundColor: "#f5f7fa",
  position: "fixed",
  bottom: 0,
  width: "94%",
};

export default InspectCreacteScreen;
